document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-quick-add]');
  if (!button) return;

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  if (button.disabled) return;
  button.disabled = true;
  const originalText = button.textContent;
  const addedText = button.dataset.addedText || originalText;

  const body = new URLSearchParams();
  body.set('items[0][id]', variantId);
  body.set('items[0][quantity]', 1);

  fetch('/cart/add.js', {
    method: 'POST',
    body,
  })
    .then((response) => response.json())
    .then(() => {
      button.textContent = addedText;

      const drawer = document.querySelector('cart-drawer');
      const openAndRefresh = () => {
        if (drawer && typeof drawer.open === 'function') drawer.open(true);
        if (drawer && typeof drawer.refresh === 'function') {
          drawer.refresh();
          fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
              document.querySelectorAll('[data-cart-count]').forEach((el) => {
                el.textContent = cart.item_count;
                el.hidden = cart.item_count === 0;
                el.classList.remove('is-pulse');
                void el.offsetWidth;
                el.classList.add('is-pulse');
                setTimeout(() => el.classList.remove('is-pulse'), 500);
              });
            });
        }
      };

      if (drawer && typeof drawer.open === 'function') {
        openAndRefresh();
      } else if (drawer) {
        customElements.whenDefined('cart-drawer').then(openAndRefresh);
      }

      const cartPage = document.querySelector('cart-page');
      if (cartPage && typeof cartPage.refresh === 'function') cartPage.refresh();

      setTimeout(() => {
        button.textContent = originalText;
      }, 2000);
    })
    .catch(() => {
      button.textContent = originalText;
    })
    .finally(() => {
      button.disabled = false;
    });
});
